export default {"src":"/_next/static/media/grill-corner.1e5aba5c.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};